import React, {useState, useEffect} from "react"
import _ from "lodash";
import api from "api";
import { connect } from 'react-redux';
import stateMap from "../../store/stateMap";
import { Waypoint } from 'react-waypoint';
import update from 'immutability-helper';
import {ReactComponent as SVGTrash} from '../../assets/trash.svg';
import { AvatarReducer, AvatarPicture1} from "component/Avatar";
import { format, parseISO, isValid, formatDistanceToNow } from 'date-fns';
import "./index.scss";
import { Link, createSearchParams } from "react-router-dom";
import { popinfo } from "component/Fancybox/Fancybox";

const NotifList = connect(stateMap)((props) => {
    const [notifs, setNotifs]       = useState(false);

    const [listArgs, setListArgs]   = useState(props.listArgs);
    const [fetching, setFetching]   = useState(false);

    const [paginationParams]     = useState({
        paged : 1
        ,posts_per_page : 20
    });


    useEffect(() => {
        
        setListArgs(props.listArgs || {
            paged : 1
        });

    }, props.listArgs ? [props.listArgs.refresh] : []);

    const LoadNotifs = () => {

        if(!props.auth.user)
        {
            return;
        }

        console.log(listArgs);
    
        var args = _.assignIn({}, paginationParams, listArgs );
    
        setFetching(true);
    
        var toFetch = [
            api('/Notif', 'get', args, 'Bearer ' + props.auth.token)
        ]
    
    
        Promise.all(toFetch)
            .then((response) => {
                
    
                if(response[0].notif.length == 0)
                {
                    setFetching('EOF');
                }
                else
                {
    
                    if(notifs !== false)
                    {
                        setNotifs( notifs.concat(response[0].notif));
                    }
                    else
                    {
                        setNotifs(response[0].notif);
                    }
    
                    setListArgs(update(listArgs, {
                        paged : {$set : listArgs.paged + 1}
                        ,refresh : {$set : listArgs.refresh + 1}
                    }));

                    setFetching(false);
                }
    
            })
            .catch((error) => {
                setFetching(false);
    
                setNotifs([]);
            })
    }

    const ReadAllNotifs = () => {

        let message = popinfo('loading', 'Dimiss Notification', 'Be sure to re-read the notifications');

        api('/Notif/ReadAll', 'post', {}, 'Bearer ' + props.auth.token)
            .then(() => {
                message.close();

                let AllReadNotifs = notifs;
                _.each(notifs, (notif, index) => {
                    AllReadNotifs = update(AllReadNotifs, {
                        $splice : [[index, 1, update(notif, {
                            IsRead : {$set : 1}
                        })]]
                    });
                });
                setNotifs(AllReadNotifs);

            })
            .catch(error => {
                popinfo('error', 'Dismiss Notification', error, {}, message);
            })
    }

    return (
        listArgs !== false &&
        <div className="component-notif-list">
            {
                notifs !== false &&
                <div className="text-right mb-md">
                    <button className="text-sm color-brand" onClick={ReadAllNotifs}> <SVGTrash/> Dismiss All</button>
                </div>
            }
            <ul className="notifs">
                {
                    notifs !== false && notifs.map((notif) => {

                        return (
                            <li className={`notif ${notif.IsRead == 0 && 'un-read'} ${notif.IsGlanced == 0 && 'un-glanced'}`} key={notif.NotifID}>
                                <div className="notif-wrapper">
                                    <Link className="absolute inset" to={{
                                        pathname : "/notification"
                                        ,search : `?${createSearchParams({
                                            nid : notif.NotifID
                                        })}`
                                    }}/>
                                    <div className="notif-header-meta">
                                        <span className="text-sm">
                                            {notif.SenderType == 'admin' && 'Crowdbees Teams'}    
                                            {notif.SenderType == 'system' && 'Crowdbees'}    
                                            {notif.SenderType == 'user' && notif.Sender_UserDisplayName}    
                                        </span>
                                    </div>
                                    <div className="notif-body">
                                        <div className="notif-source">
                                            {
                                                notif.SenderType == 'user' &&
                                                <AvatarPicture1 user={AvatarReducer(notif, 'Sender_')}/>
                                            }
                                        </div>
                                        <div className="notif-message">
                                            <div className="notif-message-text leading-text" dangerouslySetInnerHTML={{__html : notif.NotifBody}}></div>
                                            <span className="notif-date block text-xs">
                                                {formatDistanceToNow(parseISO(notif.NotifDate), 'dd LLLL Y HH:mm:ss')} ago
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        )
                    } )
                }
                {
                    fetching !== 'EOF' && 
                    (
                        <Waypoint onEnter={LoadNotifs} >
                            <li className="notif skeleton-notif">
                            {
                                fetching && <span className="skeleton"></span> 
                            }
                            </li>
                        </Waypoint>
                    )
                }
            </ul>
            {
                notifs !== false && fetching !== 'EOF' &&
                <div className="text-center  mt-md">
                    <button onClick={LoadNotifs} className="color-brand text-xs">Load More</button>
                </div>
            }
        </div>
    )
});

export {NotifList}